import React from 'react';
import { ApplicationSettings } from 'titus-ts/dist/js/Settings/ApplicationSettings';
import { SELECT_CLASSIFICATION_MODE } from '../../../store/select-classification/types';
import PaneCommandBar from './PaneCommandBar';
import DialogCommandBar from './DialogCommandBar';

type CommandBarProps = {
    onPaneOk: () => void;
    onDialogOk: () => void;
    onDialogCancel: () => void;
    appSettings: ApplicationSettings;
    okEnabled: boolean;
    mode: SELECT_CLASSIFICATION_MODE;
};

const CommandBar = (props: CommandBarProps) => {
    const { onPaneOk, onDialogOk, onDialogCancel, appSettings, okEnabled, mode } = props;

    let okText, okTooltip;
    if (!mode) {
        okText = appSettings?.ClassificationTaskPane?.MetadataApplyButtonText;
        okText = okText ? okText : 'Apply';

        okTooltip = appSettings?.ClassificationTaskPane?.MetadataApplyButtonTooltipText;
        okTooltip = okTooltip ? okTooltip : undefined;
    } else if (mode == 'portion') {
        okText = appSettings?.ClassificationTaskPane?.MetadataApplyButtonText || 'Apply';
        okTooltip = appSettings?.ClassificationTaskPane?.MetadataApplyButtonTooltipText;
    }

    return (
        <div style={{ margin: '8px 16px' }}>
            {(!mode || mode == 'portion') && (
                <PaneCommandBar onOk={onPaneOk} okText={okText} okTooltip={okTooltip} okEnabled={okEnabled} />
            )}
            {mode && mode != 'portion' && (
                <DialogCommandBar
                    onOk={onDialogOk}
                    onCancel={onDialogCancel}
                    appSettings={appSettings}
                    okEnabled={okEnabled}
                />
            )}
        </div>
    );
};

export default CommandBar;
